<!--
* @description  参数1
* @fileName  detailEdit
* @author userName
* @date 2024-01-02 14:56:30
!-->
<template>
  <div id="changeEmail" class="changeEmail">
    <DialogEidt :value="isShow" @close="closeDialog">
        <template v-slot:title>
            <div>Change - Email</div>
        </template>
        <template v-slot:body>
            <div class="main-info p24 check-price-form">
            <el-form :model="formData"
            :rules="allRules"
            ref="formData"
            label-position="top"
            size="medium"
            @submit.native.prevent
            class="item-Surcharge">
              <el-form-item class="flex-width_1" prop="email" label="New email">
                <el-input v-model="formData.email"></el-input>
              </el-form-item>
              <el-form-item class="flex-width_1" prop="password" label="Password">
                <el-input type="password" v-model="formData.password"></el-input>
              </el-form-item>
            </el-form>
            </div>
        </template>
        <template v-slot:footer>
            <div class="foot-class">
                <button class="cancel" @click="closeDialog">Cancel</button>
                <button class="save by-button--primary" @click="clickSave">Save</button>
            </div>
        </template>
    </DialogEidt>
  </div>
</template>

<script>
import DialogEidt from '../../../components/Dialog/Dialog.vue'
import request from '@/utils/request'
import { getCookie } from '@/utils/cookiejs'
export default {
  props: {
    // 父辈向子辈传参
    isShow:{
        type:Boolean,
        default:()=>{
            return false
        }
    }
  },
  name: "changeEmail",
  data() {
    return {
        formData:{
            email:'',
            password:'',
        },
		token: "",
		btnLoading: false,
        allRules:{
            email: [
            { required: true, trigger: "blur", message: "Please enter email address." },
			{
			    pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
			    message: "The email you entered is incorrect. Please try again.",
				trigger: 'blur'
			  },
            ],
            password: [
            { required: true, trigger: "blur", message: "Please enter password." },
            ],
            },
        };
  },
  created() {
	this.token = getCookie('token')
	if (this.token) {
		this.getCustomerInfo()
	}
  },
  computed: {
    // 计算属性
  },
  components: {
    // 组件的引用
    DialogEidt
  },
  methods: {
    // 方法
    closeDialog() {
      this.$emit("close",false)
    },
    clickSave(){
      //表单校验
      this.$refs["formData"].validate((val) => {
        // console.log("====校验", val);
        if (val) {
			request({
				url: '/Config/Actions/CheckMail',
				method: 'POST',
				data: this.formData,
				headers: {
					Authorization: this.token
				},
			}).then((res) => {
				this.$message({
					message: res.msg,
					type: 'success',
					duration: 1000,
					onClose: () => {
						this.btnLoading = false;
						this.closeDialog()
						this.$emit('refresh', true)
					}
				})
			}).finally(() => {
				this.btnLoading = false;
			})
		}
      })
    }
  },
  mounted() {
    // 页面进入时加载内容
  },
  watch: {
    // 监测变化
  },
};
</script>
<style scoped lang='scss'>
::v-deep .dialog__header{
    text-align: left ;
}
::v-deep .dialog__body{
    padding:0;
    .el-form-item{
        margin-bottom: 0;
        .el-form-item__label{
            float: left;
        }
    }
}
::v-deep .el-form-item__error {
	display: block !important;
}
.foot-class{
    margin: 24px 0;
    padding-bottom: 24px;
    text-align: right;
    .cancel{
       width: 72px;
       height: 32px;
       background: #FFFFFF;
       border-radius: 4px;
       border: 1px solid #DDDDDD; 
       font-size: 14px;
       font-family: PingFangSC, PingFang SC;
       font-weight: 500;
       color: #333333;
       margin-right: 16px;
       cursor: pointer;
    }
    .save{
        width: 72px;
        height: 32px;
        border-radius: 4px;
        cursor: pointer;
    }
}
</style>